// extracted by mini-css-extract-plugin
module.exports =  {"wrap":"_9330de7794--wrap--fOeBL","tabs":"_9330de7794--tabs--BRtlE"};